import { render, staticRenderFns } from "./AppointmentPayment.vue?vue&type=template&id=fc7860be"
import script from "./AppointmentPayment.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppointmentPayment.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppointmentPayment.vue?vue&type=style&index=0&id=fc7860be&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports